export enum SpecificationType {
  STANDARD = 'standard',
  ORGANIC = 'organic',
  NPR = 'npr',
  CUSTOMER = 'customer',
}
